import { BlocksIconScale } from 'blocks-nextjs/blocks-web-components/components/icon/icons/scale';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconScale = createComponent({
  react: React,
  tagName: 'cat-icon-scale',
  elementClass: BlocksIconScale
});
